import { FC } from 'react';

import { Order } from '../../../types';

type Props = {
    order: Order;
};

export const CancellationDetails: FC<Props> = ({ order }) => {
    if (!order.cancellation_reason && !order.cancellation_comment) {
        return null;
    }

    return (
        <div className="mt-2 space-y-1 text-xs text-muted-foreground">
            {order.cancellation_reason && (
                <div>
                    Причина:{' '}
                    <span className="font-medium">
                        {order.cancellation_reason.name}
                    </span>
                </div>
            )}
            {order.cancellation_comment && (
                <div>
                    Коментар:{' '}
                    <span className="font-medium">
                        {order.cancellation_comment}
                    </span>
                </div>
            )}
        </div>
    );
};
